import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { appReducer } from './slices';

const persistConfig = {
    key: 'root',
    storage,
};

const persistMiddleware = {
    serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
};

export const rootReducer = (state, action) => {
    if (action.type === 'auth/logout') {
        localStorage.removeItem('persist:root');
        state = {};
    }

    return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDM) => getDM({ ...persistMiddleware }),
    devTools: process.env.NODE_ENV !== 'production',
});

export default store;
export const persistor = persistStore(store);
